import type { DataChartStyleProps } from './datachartStyleRegistry'
import { TemperatureChartBase } from './TemperatureChartBase'

export function TemperatureChartStyle02(props: DataChartStyleProps) {
  return <TemperatureChartBase variant="gold" {...props} />
}
